module.exports = __webpack_public_path__ + "static/media/cover-home-2.4b322c9b.jpg";